// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"edd12d4f","235":"18ecae20","307":"0725ef88","383":"0c02edf1","427":"c7af213f","453":"e1ea8cda","489":"842611b8","572":"a2915815","669":"e52a02b1","706":"e81ecf34","723":"1265b2f5","929":"0d1c8184"}[chunkId] + ".chunk.js";
};